/**
 * Contact tabs
 *
 * @since   1.0.0
 * @package blujay
 */

(function($) {

	$( document ).ready( init );

	/**
	 * Build pill string for tags
	 *
	 * @param  {array} categories
	 * @return {string}
	 * @since  1.2.0
	 */
	function getPills( categories ) {
		return '<span class="pills"><span class="pill">' + categories.join( '</span><span class="pill">' ) + '</span></span>';
	}

	/**
	 * Fire off featured posts/news stuff
	 *
	 * @since 1.2.0
	 */
	function init() {

		var $featured = $('#featured');

		if ( $featured.length < 1 ) {
			return;
		}

		var url  = BLUJAY.siteURL;
		var rest = url + '/wp-json/wp/v2/';
		var foundFeatured = false,
		    post,
		    image,
		    date,
		    cards = [];

		// image to use if there is no blog image set
		var placeholderImgSrc = '' + url + '/wp-content/themes/blujay/assets/images/blujay-placeholder-img.jpg',
		    $primaryNewsFeed = $( '#primary-news-feed' ),
		    $secondaryNewsFeed = $( '#secondary-news-feed' );

		/**
		 * Featured post: Try to get this first. See localized script for tags
		 *
		 * Fire off doOtherNews once we're done
		 */
		$.ajax({
			url: rest + 'posts?_embed&per_page=1&tags=' + BLUJAY.tags.featured.term_id
		}).done( function( posts ) {

			if ( posts.length < 1 ) {
				return;
			}

			post = posts[0];
			image = post._embedded['wp:featuredmedia'] ? post._embedded['wp:featuredmedia'][0].source_url : placeholderImgSrc;
			date = post.date.split( 'T' );

			cards.push( '<div class="featured"><div class="img-container">' + getPills( post.blujay_category_names ) + '<img src="' + image + '" alt="featured news image"></div><div class="content-container featured-content"><div class="info"><span class="date">' + date[0] + '</span><h3><a href="' + post.link + '" target="_blank">' + post.title.rendered + '</a></h3></div><div class="cta"><a href="' + post.link + '" role="button">Learn More</a></div></div></div>' );

			foundFeatured = post.id;

		}).always( doOtherNews );


		/**
		 * Secondary + fallback featured posts: Just get two of the latest posts
		 * if we found a featured one. Otherwise, get three posts with the first
		 * being the featured one.
		 *
		 * @since 1.2.0
		 */
		function doOtherNews() {

			var perPage = foundFeatured ? 2 : 3,
			    exclude = foundFeatured ? '&exclude=' + foundFeatured : '';

			$.ajax({
				url: rest + 'posts?_embed&per_page=' + perPage + exclude
			}).done( function( posts ) {

				if ( posts.length < 1 ) {
					return;
				}

				// if we already have a featured post, this is a small guy and
				// is the one of two
				date = posts[0].date.split( 'T' )[0];
				if ( foundFeatured ) {
					cards.push( '<div class="secondary news"><div class="content-container"><span class="date">' + date + '</span>' + getPills( posts[0].blujay_category_names ) + '<h3><a href="' + posts[0].link + '" target="_blank">' + posts[0].title.rendered + '</a></h3>' + posts[0].excerpt.rendered.slice(0, 120) + '...' + '</div></div>' );
				} else {
					image = posts[0]._embedded['wp:featuredmedia'] ? posts[0]._embedded['wp:featuredmedia']['0'].source_url : placeholderImgSrc;
					cards.push( '<div class="featured"><div class="img-container">' + getPills( posts[0].blujay_category_names ) + '<img src="' + image + '" alt="featured news image"></div><div class="content-container featured-content"><div class="info"><span class="date">' + date + '</span><h3><a href="' + posts[0].link + '" target="_blank">' + posts[0].title.rendered + '</a></h3></div><div class="cta"><a href="' + posts[0].link + '" role="button">Learn More</a></div></div></div>' );
				}

				// second post -- always going to be "secondary"
				if ( posts[1] ) {
					date = posts[1].date.split( 'T' )[0];
					cards.push( '<div class="secondary news"><div class="content-container"><span class="date">' + date + '</span>' + getPills( posts[1].blujay_category_names ) + '<h3><a href="' + posts[1].link + '" target="_blank">' + posts[1].title.rendered + '</a></h3>' + posts[1].excerpt.rendered.slice(0, 120) + '...' + '</div></div>' );
				}

				// third post -- always secondary, but only used if a featured
				// one wasn't found
				if ( posts[2] ) {
					date = posts[2].date.split( 'T' )[0];
					cards.push( '<div class="secondary news"><div class="content-container"><span class="date">' + date + '</span>' + getPills( posts[2].blujay_category_names ) + '<h3><a href="' + posts[2].link + '" target="_blank">' + posts[2].title.rendered + '</a></h3>' + posts[2].excerpt.rendered.slice(0, 120) + '...' + '</div></div>' );
				}

				// fourth: always the button
				cards.push( '<a href="' + url + '/blog" role="button" class="blue"><span class="text">View more articles</span><span class="icon"><i class="fa fa-long-arrow-alt-right"></i></span></a>' );

				// append blocks to feed
				$.each( cards, function( index, card ) {

					if ( index == 0 ) {
						$primaryNewsFeed.append( card );
					} else {
						$secondaryNewsFeed.append( card );
					}
				});

			}).always( function() {
				$( '.preloader' ).addClass( 'display-none' );
			});
		}
	}
})( jQuery );
